export function isTextTruncated(element: any): boolean {
  return element?.scrollWidth > element?.clientWidth;
}
